export default {
  // Wage
  wageDoctors: [],
  // Doctors
  doctors: [],
}
